export interface Item {
  key: string;
  title: string;
}

export interface Props {
  activeTabClassName?: string;
  className?: string;
  disabled?: boolean;
  items: Item[];
  onToggle: () => void;
  philter?: string;
  selected: string;
  variant: TOGGLE_VARIANTS;
}

export enum TOGGLE_VARIANTS {
  ATHLETE_PROFILES = "athleteProfiles",
  SPORTS = "sports"
}
